module.exports = __webpack_public_path__ + "static/img/line-dashed.34b0843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner/line-dashed.png
// module id = 172
// module chunks = 1